<template>
  <div class="card mb-4">
    <div class="card-header">
      <strong>Resumo</strong>
    </div>
    <div class="card-body">
      <div v-for="(group, index) in reportGroups" :key="group.id">
        <p class="mb-2">
          <strong class="align-middle">{{ group.name }}</strong>
        </p>
        <p class="mb-2">
          <small v-html="`Maior: ${formatCurrency(group.max_price)}`"></small>
        </p>
        <p class="mb-2">
          <small v-html="`Menor: ${formatCurrency(group.min_price)}`"></small>
        </p>
        <p class="mb-0">
          <small v-html="`Média: ${formatCurrency(group.avg_price)}`"></small>
          <button 
            type="button" 
            class="btn btn-sm btn-link" 
            @click="togglePopover($event, 'A média é usada para encontrar o valor central típico de um conjunto de dados, fornecendo uma noção geral da tendência desses dados. É útil quando os valores são uniformes e não há extremos significativos.')"
          >
            <i class="fas fa-question-circle"></i>
          </button>
        </p>
        <p class="mb-0">
          <small v-html="`Mediana: ${formatCurrency(group.median_price)}`"></small>
          <button 
            type="button" 
            class="btn btn-sm btn-link" 
            @click="togglePopover($event, 'A mediana é usada para identificar o ponto médio de um conjunto de dados, sendo particularmente útil em situações onde os dados têm valores extremos ou são muito dispersos, já que a mediana não é afetada por esses extremos tanto quanto a média.')"
          >
            <i class="fas fa-question-circle"></i>
          </button>
        </p>
        <hr v-if="index < reportGroups.length - 1" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportGroupSummary',
  props: {
    reportGroups: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activePopover: null
    }
  },
  methods: {
    formatCurrency(value) {
      if (!value) return 'R$ 0,00'
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value)
    },
    togglePopover(event, content) {
      // Close any existing popover first
      if (this.activePopover) {
        this.activePopover.dispose()
        this.activePopover = null
      }
      
      // Create new popover
      const popover = new bootstrap.Popover(event.target, {
        content: content,
        trigger: 'manual',
        placement: 'top'
      })
      
      popover.show()
      this.activePopover = popover
      
      // Close popover when clicking outside
      setTimeout(() => {
        document.addEventListener('click', this.closePopover, true)
      }, 100)
    },
    closePopover(event) {
      if (this.activePopover && !event.target.closest('.popover') && !event.target.closest('.btn')) {
        this.activePopover.dispose()
        this.activePopover = null
        document.removeEventListener('click', this.closePopover, true)
      }
    }
  },
  beforeUnmount() {
    if (this.activePopover) {
      this.activePopover.dispose()
    }
    document.removeEventListener('click', this.closePopover, true)
  }
}
</script>